// extracted by mini-css-extract-plugin
export var customCol = "multi-column-content-with-image-module--customCol--cb285";
export var customGrid = "multi-column-content-with-image-module--customGrid--c018f";
export var heading = "multi-column-content-with-image-module--heading--4a2ea";
export var image = "multi-column-content-with-image-module--image--7cde1";
export var item = "multi-column-content-with-image-module--item--adb2d";
export var root = "multi-column-content-with-image-module--root--ad691";
export var text = "multi-column-content-with-image-module--text--e5307";